/* eslint import/prefer-default-export: 0 */
import _ from 'lodash';

import { TASK_DROPDOWN_LIST_VERTICAL_POSITIONS } from './constants';

import styles from './task_dropdown_list.scss';

const sharedVariables = {
  TASK_DROPDOWN_LIST_HEADER_HEIGHT: _.parseInt(styles.TASK_DROPDOWN_LIST_HEADER_HEIGHT),
  TASK_DROPDOWN_LIST_HEIGHT: _.parseInt(styles.TASK_DROPDOWN_LIST_HEIGHT),
  TASK_DROPDOWN_LIST_OPTION_HEIGHT: _.parseInt(styles.TASK_DROPDOWN_LIST_OPTION_HEIGHT),
  TASK_DROPDOWN_LIST_WIDTH: _.parseInt(styles.TASK_DROPDOWN_LIST_WIDTH),
};

const taskTooltipHeight = (smallDevice, heightToBottom, tasksHeight) => {
  if (smallDevice) {
    return heightToBottom;
  } else if (tasksHeight > heightToBottom) return sharedVariables.TASK_DROPDOWN_LIST_HEIGHT;
  else {
    return sharedVariables.TASK_DROPDOWN_LIST_HEADER_HEIGHT + tasksHeight >
      sharedVariables.TASK_DROPDOWN_LIST_HEIGHT
      ? sharedVariables.TASK_DROPDOWN_LIST_HEIGHT
      : sharedVariables.TASK_DROPDOWN_LIST_HEADER_HEIGHT + tasksHeight;
  }
};

export const tooltipVerticalPosition = (
  containerTableHeight,
  tasksHeight,
  position,
  paddingVerticalRemoval,
) => {
  const yPosition = _.get(position, 'y');
  const windowInnerHeight = _.get(window, 'innerHeight');
  const heightToBottom = windowInnerHeight - yPosition;

  const smallDevice =
    containerTableHeight < sharedVariables.TASK_DROPDOWN_LIST_HEIGHT &&
    tasksHeight > heightToBottom;
  const tasksTooltipHeight = taskTooltipHeight(smallDevice, heightToBottom, tasksHeight);

  const isEnoughHeightSpace = heightToBottom - paddingVerticalRemoval >= tasksTooltipHeight;
  return isEnoughHeightSpace || smallDevice
    ? TASK_DROPDOWN_LIST_VERTICAL_POSITIONS.BOTTOM
    : TASK_DROPDOWN_LIST_VERTICAL_POSITIONS.TOP;
};
